<template>
    <va-edit-layout>
        <AffordabilityExpenseEvent-form
            :id="id"
            :title="title"
            :item="item"
        ></AffordabilityExpenseEvent-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
